import { cn } from 'utils/bem';

export const avatar = cn('avatar');
